<template>
    <header>
        <div class="bg-primary transition-shadow fixed w-full px-2 top-0 z-10">
            <div class="__sides relative flex items-center justify-between h-[5.5em] text-xs font-normal">
                <div @click="SET_SHOW_SIDE_NAV(!getshowSideNav)"
                    class="flex items-center justify-center text-primary_text lg:hidden cursor-pointer">
                    <svg class="h-7 w-7" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                    </svg>
                </div>

                <router-link to="/">
                    <img alt="Logo" :src="logo || '/img/logo.png'" class="h-9 sm:h-11 bg-transparent">
                </router-link>

                <div class="flex items-center justify-center space-x-2 lg:space-x-6 right-12 px-4">
                    <div class="items-center hidden space-x-3 md:flex ">
                        <!-- Pesquisa Menu -->
                        <router-link to="/faq" class="flex items-center p-2 hover:opacity-80">
                            <svg class="w-7 h-7 text-primary_text" xmlns="http://www.w3.org/2000/svg" fill="none"
                                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
                            </svg>
                        </router-link>
                        <!-- Notification Menu -->
                        <router-link to="/notification" v-if="!getLoadingUser && getUser" :class="'group/principal'"
                            class="flex relative h-[5.5em] items-center p-2">
                            <li :class="'group/principal'" class="relative flex h-[5.5em] items-center">
                                <svg class="w-7 h-7 text-primary_text" xmlns="http://www.w3.org/2000/svg" fill="none"
                                    viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" />
                                </svg>
                                <ul
                                    :class="'group-hover/principal:block absolute hidden right-0 top-[4.1rem] w-96 bg-white divide-y border border-t-2 border-t-[#159EEC] rounded shadow-lg z-20'">
                                    <NotificationComponent />
                                </ul>
                            </li>
                            <div v-if="getNotificationQntPendente > 0"
                                class="absolute top-2.5 right-1 h-4 w-4 text-[0.55rem] text-center text-white bg-indigo-500 rounded-full ">
                                {{ getNotificationQntPendente }}</div>
                        </router-link>
                        <!-- Icon User Menu -->
                        <div class="relative">
                            <router-link to="/profile/account" v-if="!getLoadingUser && getUser"
                                class="flex items-center gap-2 text-primary_text">
                                <img v-if="getUser.image && imageLoaded" @error="imageLoaded = false" :src="imageUrl"
                                    class="rounded-full h-7 w-7 flex items-center justify-center" />
                                <div v-else class="rounded-full h-7 w-7 bg-secondary flex items-center justify-center">
                                    <span v-if="!getLoadingUser && getUser && getUser.firstName && getUser.lastName"
                                        class="text-white text-xs">
                                        {{ getUser && getUser.firstName ? getUser.firstName.charAt(0) : '' }}{{ getUser
                                            && getUser.lastName ? getUser.lastName.charAt(0) : '' }}
                                    </span>
                                    <span v-else class="text-white text-xs">
                                        <svg class="w-5 h-5 text-white" viewBox="0 0 24 24" fill="currentColor"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M11.6757 12.1352C10.6128 12.1352 9.70296 11.7568 8.94609 10.9999C8.18922 10.2431 7.81079 9.33322 7.81079 8.27038C7.81079 7.20754 8.18922 6.29769 8.94609 5.54082C9.70296 4.78395 10.6128 4.40552 11.6757 4.40552C12.7385 4.40552 13.6483 4.78395 14.4052 5.54082C15.1621 6.29769 15.5405 7.20754 15.5405 8.27038C15.5405 9.33322 15.1621 10.2431 14.4052 10.9999C13.6483 11.7568 12.7385 12.1352 11.6757 12.1352ZM3.94592 19.865V17.1596C3.94592 16.612 4.08683 16.1088 4.36864 15.6499C4.65046 15.1909 5.02486 14.8407 5.49187 14.5991C6.49029 14.0999 7.50482 13.7255 8.53545 13.4759C9.56608 13.2263 10.6128 13.1015 11.6757 13.1015C12.7385 13.1015 13.7852 13.2263 14.8159 13.4759C15.8465 13.7255 16.861 14.0999 17.8594 14.5991C18.3264 14.8407 18.7009 15.1909 18.9827 15.6499C19.2645 16.1088 19.4054 16.612 19.4054 17.1596V19.865H3.94592ZM5.87836 17.9325H17.473V17.1596C17.473 16.9824 17.4287 16.8214 17.3401 16.6765C17.2515 16.5315 17.1348 16.4188 16.9898 16.3383C16.1202 15.9035 15.2426 15.5774 14.3569 15.36C13.4712 15.1426 12.5775 15.0339 11.6757 15.0339C10.7739 15.0339 9.8801 15.1426 8.9944 15.36C8.1087 15.5774 7.23106 15.9035 6.36146 16.3383C6.21653 16.4188 6.09978 16.5315 6.01121 16.6765C5.92264 16.8214 5.87836 16.9824 5.87836 17.1596V17.9325ZM11.6757 10.2028C12.2071 10.2028 12.662 10.0136 13.0404 9.63516C13.4189 9.25673 13.6081 8.8018 13.6081 8.27038C13.6081 7.73896 13.4189 7.28404 13.0404 6.9056C12.662 6.52717 12.2071 6.33795 11.6757 6.33795C11.1442 6.33795 10.6893 6.52717 10.3109 6.9056C9.93244 7.28404 9.74322 7.73896 9.74322 8.27038C9.74322 8.8018 9.93244 9.25673 10.3109 9.63516C10.6893 10.0136 11.1442 10.2028 11.6757 10.2028Z" />
                                        </svg>
                                    </span>
                                </div>
                                <p>{{ getUser.firstName }} {{ getUser.lastName }}</p>
                            </router-link>
                            <router-link v-else to="/auth"
                                class="hidden __link text-primary_text md:block">Login</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="max-md:fixed w-full flex items-center justify-center h-1/3 bg-primary"></div>
    </header>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import NotificationComponent from '@/components/notification/NotificationComponent.vue'

export default {
    name: 'NavbarComponent',
    components: {
        NotificationComponent
    },
    data() {
        return {
            imageLoaded: true
        }
    },
    computed: {
        ...mapGetters(['getUser', 'getLoadingUser', 'getshowSideNav', 'logo']),

        getNotificationQntPendente() {
            const n = this.$store.state.notifications?.totalPendente;
            return n != null ? Number(n) : 0;
        },

        imageUrl() {
            return `${process.env.VUE_APP_URL_SERVER}/uploads/users/${this.getUser.image}`;
        }
    },
    methods: {
		...mapActions(['notificationQntPendente']),
        ...mapMutations(['SET_SHOW_SIDE_NAV']),
    },
    mounted(){
        if (this.getUser && localStorage.getItem('token')) {
            this.notificationQntPendente()
        }
    },
    // watch: {
    // '$store.state.notifications.totalPendente': function () {
    //   if (this.$store.state.helpers.isMenuOpen) {
    //     document.documentElement.style.overflow = 'hidden'
    //   } else {
    //     document.documentElement.style.overflow = null
    //   }
    // }
    // },
}
</script>

<style>
@media screen and (max-width: 768px) {
    .center-title {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    }
}

.__link {
    text-decoration: none;
    position: relative;
}

.__link::after {
    bottom: -4px;
    content: "";
    display: block;
    height: 2px;
    left: 0;
    position: absolute;
    background: rgb(31 41 55);
    opacity: 0.6;
    transition: width 0.3s ease 0s, opacity 0.3s ease 0s;
    width: 0;
}

.__link:hover::after {
    width: 100%;
    opacity: 0.9;
}
</style>